import List from "./List";
import Form from "./Form";

const ItemFlows = {
    List,
    Form,
};

export default ItemFlows;
